import { render, staticRenderFns } from "./KakaoChannelIcon.vue?vue&type=template&id=83dc815c&scoped=true&"
import script from "./KakaoChannelIcon.vue?vue&type=script&lang=js&"
export * from "./KakaoChannelIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83dc815c",
  null
  
)

export default component.exports